var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"item.glutenfree",fn:function(ref){
var item = ref.item;
return [_c('v-simple-checkbox',{attrs:{"disabled":""},model:{value:(item.glutenfree),callback:function ($$v) {_vm.$set(item, "glutenfree", $$v)},expression:"item.glutenfree"}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }